module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-regular.ca4c4b9.eot";